module.exports = __webpack_public_path__ + "static/media/g.bf9d9dad.svg";